import axiosPublicInstance from './AxiosPublicInstance';

export const getCountryList = async () => {
    try {
        const result = await axiosPublicInstance.get(`country-list/`);
        const resultData = result.data.data;

        const countryOptions = resultData.map(each => ({
            label: each.country,
            value: each.id, // or keep as code if your real API has it
        }));

        return countryOptions;
    } catch (error) {
        console.error("Error fetching country list:", error);
        return [];
    }
};


export const getStateList = async countryId => {
    const result = await axiosPublicInstance.get(
        `state-list/?country_id=${countryId}`
    );
    const resultData = result.data.data;

    const stateOptions = resultData.map(each => ({
        label: each.state,         // use the correct key
        value: each.id     // or each.id, depending on usage
    }));

    return stateOptions;
};



export const getCityList = async (countryId, stateId) => {
    try {
        const result = await axiosPublicInstance.get(
            `city-list/?country_id=${countryId}&state_id=${stateId}`
        );
        const resultData = result.data.data || [];

        const cityOptions = resultData.map(each => ({
            label: each.city, // show city name
            value: each.id    // use ID as value or use `each.city` if required
        }));

        

        return cityOptions;
    } catch (error) {
        console.error("Error fetching city list:", error);
        return [];
    }
};


// export const getStateList = async countryId => {
//     let result = await axiosPublicInstance.get(
//         `state-list/?country_id=${countryId}`
//     );
//     console.log('state-list', result);
//     let resultData = result.data.data;
//     resultData.forEach(each => {
//         Object.defineProperty(
//             each,
//             'label',
//             Object.getOwnPropertyDescriptor(each, 'state_name')
//         );
//         Object.defineProperty(
//             each,
//             'value',
//             Object.getOwnPropertyDescriptor(each, 'code')
//         );
//         delete each['state_name'];
//         delete each['code'];
//     });
//     return resultData;
// };

// export const getCityList = async (countryId, stateId) => {
//     let result = await axiosPublicInstance.get(
//         `city-list/?country_id=${countryId}&state_id=${stateId}`
//     );
//     let resultData = result.data.data;
//     console.log('city-list', resultData);
//     resultData.forEach(each => {
//         Object.defineProperty(
//             each,
//             'label',
//             Object.getOwnPropertyDescriptor(each, 'state_name')
//         );
//         Object.defineProperty(
//             each,
//             'value',
//             Object.getOwnPropertyDescriptor(each, 'code')
//         );
//         delete each['state_name'];
//         delete each['code'];
//     });
//     return resultData;
// };
